import { Card, CardContent, Skeleton, Stack } from '@mui/material'
import { FC } from 'react'
import { Icons, ItemImageAreaSkeleton, SkeletonText } from 'utoniq-ui'

export type TradeBoxSkeletonProps = {
  fullWidth?: boolean
}

export const TradeBoxSkeleton: FC<TradeBoxSkeletonProps> = ({
  fullWidth = false,
}) => {
  return (
    <Card
      elevation={0}
      sx={{
        position: 'relative',
        overflow: 'visible',
        width: fullWidth ? '100%' : 315,
      }}
    >
      <CardContent>
        <Stack direction="row" flex={1} alignItems="center" spacing={2} pb={4}>
          <AvatarWithName />
          <Icons.TradeArrow sx={{ color: 'grey.100' }} />
          <AvatarWithName reverse />
        </Stack>
        <Stack direction="row" flex={1} spacing={2}>
          <ItemImageAreaSkeleton size="x-small" />
          <Stack flex={1} justifyContent="space-between">
            <Stack mr={4}>
              <SkeletonText
                variant="small"
                width={144}
                lastWidth={64}
                numberOfLine={2}
              />
            </Stack>
            <Stack ml={4} alignItems="flex-end">
              <SkeletonText
                variant="small"
                width={144}
                lastWidth={64}
                numberOfLine={2}
              />
            </Stack>
          </Stack>
          <ItemImageAreaSkeleton size="x-small" />
        </Stack>
        <Stack direction="row-reverse" sx={{ pt: 2 }}>
          <SkeletonText variant="small" width={48} />
        </Stack>
      </CardContent>
    </Card>
  )
}

type AvatarWithNameProps = {
  reverse?: boolean
}

const AvatarWithName: FC<AvatarWithNameProps> = ({ reverse = false }) => (
  <Stack
    direction={reverse ? 'row-reverse' : 'row'}
    alignItems="center"
    flex={1}
    spacing={2}
  >
    <Skeleton variant="circular" width={28} height={28} />
    <Skeleton variant="small" width={80} />
  </Stack>
)
